import retinajs from "retinajs";

retinajs;

import "./global/sequense";
import "./import/modules";
import "./import/components";
import "./global/dropdown";
import "./global/accordeon";
import "./global/animate";
import "./global/tabs";